$(document).ready(function () {

  // footer
  $(document).on("click", ".footer-block", function () {
    $(this).toggleClass("active");
  });

  // Section dynamique
  if ($(".multicolumn-card").length) {
    $(".multicolumn-card").click(function (e) {
      var redirect = $(this).find("a").attr("href");
      if (redirect) {
        window.location.href = redirect;
      }
    });
  }

  // Page collection
  // filters
  $(document).on("click", ".mobile-facets__summary", function () {
    $(this).toggleClass("active");
    $(this).next().toggle();
  });

  $(document).on('click', '.mobile-facets__label', function () {
    // attends 500ms pour que le DOM soit bien chargé
    setTimeout(function () {
      initSwipers();
    }, 800);
  });

  // Apparition bouton "Lire plus" sur les sections SEO
  if ($(".clamped").length) {
    $(document).on("click", ".read_more", function (e) {
      $(this).prev(".clamped").toggleClass("extend");
      $(this).find("span").toggleClass("hide");
      $(this).find("span").toggleClass("show");
    });
  }

  // Quick add behavior
  if ($(".quick-add").length) {

    $(document).on('click', '.open_quickadd', function () {

      // Define height and position of quick add popin
      if ($(window).width() > 749) {
        $(".quick-add").each(function () {
          var cardContentHeight = $(this).siblings(".card").find(".elx_card").height();
          $(this).css("bottom", cardContentHeight + "px");
        });
      }
      $(window).on("resize", function () {
        $(".quick-add").each(function () {
          var cardContentHeight = $(this).siblings(".card").find(".elx_card").height();
          $(this).css("bottom", cardContentHeight + "px");
        });
      });

      var $thisQuickAdd = $(this).parents(".card").next(".quick-add");
      $(".open_quickadd").css("opacity", "1").css("z-index", "10");;
      $(".quick-add").not($thisQuickAdd).removeClass("opened");
      $(this).css("opacity", "0").css("z-index", "9");
      $thisQuickAdd.find(".quick_add_pop").show();
      $thisQuickAdd.addClass("opened");
      setTimeout(function () {
      }, 300);
    });

    $(document).on('click', '.close_quickadd', function () {
      var $thisQuickAdd = $(this).parents(".quick-add");
      $(".open_quickadd").css("opacity", "1").css("z-index", "10");
      $thisQuickAdd.find(".quick_add_pop").hide();
      $thisQuickAdd.removeClass("opened");
      setTimeout(function () {
      }, 300);
    });
  }

  // Product page
  // Sticky addtocart en mobile
  // Sticky button sur fiche produit

  //swiper mobile
   if ($(".product_page_section .product_swiper").length && $(window).width() < 990) {
    var $swiperContainer = $(".product_page_section .product_swiper");
    var slideCount = $swiperContainer.find(".swiper-slide").length;

    if (slideCount === 1) {
      $swiperContainer.addClass("single-slide");
    }

    var productSwiper = new Swiper(".product_page_section .product_swiper", {
      loop: slideCount > 1,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
      },
    });

    document.body.addEventListener('modalClosed', function () {
      setTimeout(function () {
        productSwiper.update();
      }, 0);
    });
  }
  // Sticky add to cart - mobile uniquement
  if (typeof window.IntersectionObserver !== 'undefined' && $(window).width() < 750 && $('#sticky_basket').length) {
    var $stickyBasket = $('#sticky_basket');
    var stickySectionId = $stickyBasket.data('section');
    var stickyHasOnlyDefault = $stickyBasket.data('has-only-default-variant') === true;
    var stickyIsAvailable = $stickyBasket.data('available') === true;

    // Retourne le bouton principal (re-requêté car le thème le remplace dans le DOM à chaque changement de variante)
    function getStickyMainButton() {
      return document.getElementById('ProductSubmitButton-' + stickySectionId);
    }

    // On observe le conteneur .product-form__buttons (stable dans le DOM, contrairement au bouton lui-même qui est remplacé à chaque changement de variante)
    var stickyObserverTarget = document.querySelector('#product-form-' + stickySectionId + ' .product-form__buttons');
    if (stickyObserverTarget) {
      var stickyObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            $stickyBasket.hide();
          } else {
            $stickyBasket.show();
          }
        });
      }, { threshold: 0 });
      stickyObserver.observe(stickyObserverTarget);
    }

    // Mise à jour du texte et de l'état au changement de variante
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        if (String(event.data.sectionId) !== String(stickySectionId)) return;
        var variant = event.data.variant;
        stickyIsAvailable = variant ? variant.available : false;

        var $stickyBtn = $stickyBasket.find('.sticky_button');
        if (stickyIsAvailable) {
          // Reflète le texte du bouton principal (déjà mis à jour par le thème)
          var mainBtn = getStickyMainButton();
          var mainText = mainBtn ? $(mainBtn).find('> span').first().text().trim() : '';
          if (mainText) $stickyBtn.text(mainText);
        } else {
          var bisText = $('.klaviyo-bis-trigger').text().trim();
          $stickyBtn.html(bisText ? '<span class="bis_trigger">' + bisText + '</span>' : $stickyBtn.html());
        }
      });
    }

    $(document).on('click', '#sticky_basket .sticky_button', function() {
      if (!stickyIsAvailable) {
        $('.klaviyo-bis-trigger').trigger('click');
      } else if (!stickyHasOnlyDefault) {
        var $variantPicker = $('#variant-radios-' + stickySectionId);
        if ($variantPicker.length) {
          $('html, body').animate({ scrollTop: $variantPicker.offset().top - 80 }, 400);
        }
      } else {
        var mainBtn = getStickyMainButton();
        if (mainBtn) $(mainBtn).trigger('click');
      }
    });
  }

  // Ouverture Guide des tailles
  $(document).on('click', '.sizing_btn', function () {
    $("body").addClass("overflow-hidden");
    $("#drawer_sizing.drawer").addClass("active");
  });

  // Fermeture Guide des tailles
  $(document).on('click', '#drawer_sizing.drawer #close, #drawer_sizing.drawer', function () {
    $("#drawer_sizing.drawer").removeClass("active");
      $("body").removeClass("overflow-hidden");
  });

  // Ouverture disponibilité
  $(document).on('click', '.shop_availability', function () {
    $("body").addClass("overflow-hidden");
    $("#drawer_disponibilite.drawer").addClass("active");
  });

  // Fermeture disponibilité
  $(document).on('click', '#drawer_disponibilite.drawer .drawer_close, #drawer_disponibilite.drawer', function () {
    $("body").removeClass("overflow-hidden");
    $("#drawer_disponibilite.drawer").removeClass("active");
  });

  // Ouverture et Fermture PLus de couleurs
  $(document).on('click', '.associated_product .more_colors', function () {
    $("body").addClass("overflow-hidden");
    $("#drawer_other_colors.drawer").addClass("active");
  });

  $(document).on('click', '#drawer_other_colors.drawer .icon-close, #drawer_other_colors.drawer', function () {
    $("#drawer_other_colors.drawer").removeClass("active");
    $("body").removeClass("overflow-hidden");
  });

  $(document).on('click', '.drawer_wrapper_inner', function (event) {
    event.stopPropagation();
  });

  // Tabs
  if ($('.product_tabs').length) {
    $(".product_tabs h3").click(function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).next(".tab_content").hide();
      } else {
        $(".product_tabs h3").removeClass("active");
        $(".product_tabs .tab_content").hide();
        $(this).addClass("active");
        $(this).next(".tab_content").show();
      }
    });
  }

  if ($('#sizing_content').length) {
    $("#sizing_content nav em").click(function () {
      var $name = $(this).data("name");
      $("#sizing_content nav em").removeClass("selected");
      $(this).addClass("selected");
      $('#sizing_content .tab_content').hide();
      $('#sizing_content .tab_content[data-target="' + $name + '"]').show();
    });
  }

  $(".drawer_close").click(function (e) {
    $(".shop_availability").toggleClass("active");
  });

  // Sizing switch guide des tailles
  $(document).on('click', '.pop .close, .pop', function () {
    $("body").removeClass("overflow-hidden");
    $(".pop").fadeOut();
    $(".pop_content").removeClass("active");
  });

  $(document).on('click', '.pop_content', function (event) {
    event.stopPropagation();
  });

  if ($('.size_switch').length) {
    $(".size_switch").click(function () {
      $(this).find(".switch").toggleClass("on");
      $(this).siblings("table.cm, table.in").toggleClass("opened");
      $("table.cm, table.in").toggleClass("opened");
    });
  }

  $(".agec p:first-of-type").click(function () {
    $(".agec > div").toggle();
  });

  // Homepage + carousel photos ambiance
  if ($('.carrousel, .carrousel-media').length) {
    $('.carrousel, .carrousel-media').slick({
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      centerMode: true,
      focusOnSelect: true,
      variableWidth: true
    });
  }

  if ($('.elx-collage').length) {
    if ($(window).width() < 749) {
      $('.elx-collage').slick({
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        variableWidth: true
      });
    }
  }

  // Panier
  // L'attribut "commentaire" est construit dans le champ caché #commentaire_value :
  // "magazine anniversaire" si coché, suivi (si emballage cadeau sélectionné)
  // du message perso, ou de "boite cadeau" s'il n'y a pas de message.
  // Panier tiroir : champ caché .js-drawer-commentaire, "magazine anniversaire" si coché,
  // suivi de la partie emballage cadeau déjà enregistrée (data-gift).
  // Le choix magazine est mémorisé pour la session et synchronisé entre panier et tiroir.
  var MAGAZINE_KEY = 'molli_cart_magazine';

  var getMagazineChoice = function () {
    try { return sessionStorage.getItem(MAGAZINE_KEY); } catch (e) { return null; }
  };

  var setMagazineChoice = function (checked) {
    try { sessionStorage.setItem(MAGAZINE_KEY, checked ? '1' : '0'); } catch (e) {}
  };

  var updateCommentaire = function () {
    if (!$('#commentaire_value').length) return;
    var parts = [];
    if ($('#magazine_checkbox').is(':checked')) {
      parts.push($('#magazine_checkbox').val());
    }
    if ($('.is_gift').is(':checked')) {
      var message = $('.is_msg').is(':checked') ? $.trim($('#commentaire').val() || '') : '';
      parts.push(message !== '' ? message : $('.is_gift').val());
    }
    $('#commentaire_value').val(parts.join(' - '));
  };

  var updateDrawerCommentaire = function () {
    var $input = $('.js-drawer-commentaire');
    if (!$input.length) return;
    var parts = [];
    if ($('#CartDrawer-magazine').is(':checked')) {
      parts.push($('#CartDrawer-magazine').val());
    }
    if ($input.attr('data-gift')) {
      parts.push($input.attr('data-gift'));
    }
    $input.val(parts.join(' - '));
  };

  var applyMagazineChoice = function () {
    var choice = getMagazineChoice();
    if (choice !== null) {
      $('.is_magazine').prop('checked', choice === '1');
    }
    updateCommentaire();
    updateDrawerCommentaire();
  };

  $(document).on("change", ".is_magazine", function () {
    setMagazineChoice(this.checked);
    applyMagazineChoice();
  });

  // Le tiroir est re-rendu (ajout au panier, quantités) : on réapplique le choix mémorisé
  var cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer && 'MutationObserver' in window) {
    new MutationObserver(applyMagazineChoice).observe(cartDrawer, { childList: true, subtree: true });
  }

  applyMagazineChoice();

  if ($('#commentaire_value').length) {

    $('.is_gift').prop('checked', false);

    $('.is_gift').on("change", function () {
      if ($('.is_gift').is(':checked')) {
        $('.is_msg').removeAttr('disabled');
        $(".gift_message").show();
      } else {
        $(".gift_message").hide();
        $('.is_msg').attr('disabled', 'disabled');
        $('#commentaire').val('');
      }
      updateCommentaire();
    });

    if ($('.is_msg').length) {
      $('.is_msg').on("change", function () {
        if ($('.is_msg').is(':checked')) {
          $('#commentaire').removeAttr('disabled');
          $(".cart__note").show();
        } else {
          $('#commentaire').attr('disabled', 'disabled');
          $('#commentaire').val('');
          $(".cart__note").hide();
        }
        updateCommentaire();
      });
    }

    var maxLength = 100;
    $('#commentaire').on("input", function () {
      var textlen = maxLength - $(this).val().length;
      $('.chart_left span').text(textlen);
      updateCommentaire();
    });

    updateCommentaire();
  }

  // accordeon
   // Comportement questions FAQ, CGV, Mentions
   $(".accordeon").on("click", "h3", function () {
    var $currentQ = $(this);
    var $currentA = $currentQ.next("div");

    // Ferme toutes les autres réponses + retire leurs classes
    $(".accordeon h3").not($currentQ).removeClass("opened");
    $(".accordeon h3").not($currentQ).next("div").stop(true, true).slideUp();

    // Toggle sur l'élément cliqué
    if ($currentQ.hasClass("opened")) {
      $currentQ.removeClass("opened");
      $currentA.stop(true, true).slideUp();
    } else {
      $currentQ.addClass("opened");
      $currentA.stop(true, true).slideDown();
    }
  });

  initSwipers();

});

// Réinitialise les functions appliquées à la card product après un changement dans le DOM
var observeDOM = (function () {
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

  return function (obj, callback) {
    if (!obj || obj.nodeType !== 1) return;

    if (MutationObserver) {
      // define a new observer
      var mutationObserver = new MutationObserver(callback);

      // have the observer observe for changes in children
      mutationObserver.observe(obj, { childList: true, subtree: false });
      return mutationObserver;
    }

    // browser support fallback
    else if (window.addEventListener) {
      obj.addEventListener("DOMNodeInserted", callback, false);
      obj.addEventListener("DOMNodeRemoved", callback, false);
    }
  };
})();

// Réinitialise les functions appliquées à la card product après un changement dans le DOM
observeDOM(document.getElementById("product-grid"), function (m) {
  initSwipersLazy();
});

function initSwipers() {
  var $target = $(".mySwiper").not(".swiper-initialized");
  if ($target.length) {
    // Pour chaque élément .mySwiper non initialisé, on l'initialise via un each
    $target.each(function () {
      var swiperInstance = new Swiper($(this).get(0), {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        effect: 'fade',  // Activation de l'effet de fade
        fadeEffect: {
          crossFade: true  // Assure une transition fluide entre les slides
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
        },
        breakpoints:{
          0: {
            allowTouchMove: true,
          },
          789: {
            allowTouchMove: true,
          },
        }
      });

      // Ajout de l'effet hover sur l'image pour changer la slide
      var $swiperContainer = $(this);
      var $mediaElements = $swiperContainer.find(".swiper-slide img, .swiper-slide video");

      $mediaElements.on("mouseenter", function () {
        swiperInstance.slideToLoop(1); // Aller à la deuxième slide
      });

      $mediaElements.on("mouseleave", function () {
        swiperInstance.slideToLoop(0); // Retour à la première slide
      });

    });
  }
}

function initSwipersLazy() {
  var $target = $(".mySwiper").not(".swiper-initialized");
  if ($target.length) {
    // Pour chaque élément .mySwiper non initialisé, on l'initialise via un each
    $target.each(function () {
      var $that = $(this);
      $(this).find("img").first().on("load", function () {
        var swiperInstance = new Swiper($that.get(0), {
          loop: true,
          slidesPerView: "auto",
          spaceBetween: 0,
          effect: 'fade',  // Activation de l'effet de fade
          fadeEffect: {
            crossFade: true  // Assure une transition fluide entre les slides
          },
          scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
          }
        });

        // Ajout de l'effet hover sur l'image pour changer la slide
        var $swiperContainer = $(this);
        var $mediaElements = $swiperContainer.find(".swiper-slide img, .swiper-slide video");

        $mediaElements.on("mouseenter", function () {
          swiperInstance.slideToLoop(1); // Aller à la deuxième slide
        });

        $mediaElements.on("mouseleave", function () {
          swiperInstance.slideToLoop(0); // Retour à la première slide
        });

      });
    });
  }
}

// Product media modal — navigation latérale synchronisée
(function () {
  function initModalNavStrip(modal) {
    var content = modal.querySelector('.product-media-modal__content');
    var navStrip = modal.querySelector('.product-media-modal__nav-strip');
    if (!content || !navStrip) return null;

    var contentItems = Array.from(content.children);
    var navThumbs = Array.from(navStrip.querySelectorAll('.product-media-modal__nav-thumb'));
    if (!contentItems.length || !navThumbs.length) return null;

    function getVisibleIndices() {
      var visible = [];
      var contentRect = content.getBoundingClientRect();
      contentItems.forEach(function (item, i) {
        var rect = item.getBoundingClientRect();
        if (rect.bottom > contentRect.top && rect.top < contentRect.bottom) {
          visible.push(i);
        }
      });
      return visible;
    }

    var rafPending = false;

    function updateNav() {
      // Scroll proportionnel : même ratio que le contenu
      var contentMaxScroll = content.scrollHeight - content.clientHeight;
      var navMaxScroll = navStrip.scrollHeight - navStrip.clientHeight;
      if (contentMaxScroll > 0 && navMaxScroll > 0) {
        navStrip.scrollTop = (content.scrollTop / contentMaxScroll) * navMaxScroll;
      }

      // Overlays sur les visuels actuellement visibles
      var visibleIndices = getVisibleIndices();
      navThumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', visibleIndices.indexOf(i) !== -1);
      });

      rafPending = false;
    }

    function onScroll() {
      if (!rafPending) {
        rafPending = true;
        requestAnimationFrame(updateNav);
      }
    }

    navStrip.addEventListener('pointerup', function (event) {
      event.stopPropagation();
    });

    navThumbs.forEach(function (thumb, i) {
      thumb.style.cursor = 'pointer';
      thumb.addEventListener('click', function () {
        var item = contentItems[i];
        if (!item) return;
        var itemTop = item.getBoundingClientRect().top - content.getBoundingClientRect().top + content.scrollTop;
        content.scrollTo({ top: itemTop, behavior: 'smooth' });
      });
    });

    content.addEventListener('scroll', onScroll);
    updateNav();

    return function () {
      content.removeEventListener('scroll', onScroll);
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-modal').forEach(function (modal) {
      var cleanup = null;

      var mutObs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'open') {
            if (modal.hasAttribute('open')) {
              setTimeout(function () {
                cleanup = initModalNavStrip(modal);
              }, 150);
            } else {
              if (cleanup) {
                cleanup();
                cleanup = null;
              }
            }
            break;
          }
        }
      });

      mutObs.observe(modal, { attributes: true });
    });
  });
})();